
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1883',
  depVersions: {
  "customer-portal-app": "static-1.1883",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9557",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24983",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5476",
  "hs-test-utils": "static-1.7893",
  "hub-http": "static-1.6100",
  "hub-http-shared-msw-handlers": "static-1.9677",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17865",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11324",
  "I18n": "static-7.1598",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6351",
  "payment-link-components": "static-1.23171",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6839",
  "quartz-core": "static-1.6058",
  "react": "static-7.182",
  "react-colorpicker": "static-2.10091",
  "react-dlb": "static-1.74",
  "react-utils": "static-2.5249",
  "rich-text-lib": "static-1.19619",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17797",
  "ui-components-test-utils": "static-1.5462",
  "UIComponents": "static-3.8271",
  "foundations-assets": "static-1.4721",
  "foundations-components": "static-1.7676",
  "foundations-theming": "static-1.4292",
  "foundations-theming-specialty": "static-1.2008",
  "framer-motion": "static-1.69",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.664",
  "quartz-config": "static-1.617",
  "quartz-routing": "static-1.269",
  "quick-fetch": "static-1.3815",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16534",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8026",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.52",
  "ui-addon-draggable": "static-3.4649",
  "ui-addon-react-router-dom": "static-1.9426",
  "usage-tracker": "static-1.7217",
  "usage-tracker-anonymous": "static-1.5634",
  "usage-tracker-core": "static-1.7067",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3308",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3116",
  "quartz-webpack": "static-1.3063",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.79",
  "customer-data-objects": "static-1.7535",
  "frontend-preferences-client": "static-1.7805",
  "laboratory-lib": "static-3.7041",
  "onboarding-scopes": "static-1.6344",
  "rpc-client-utils": "static-1.4524",
  "ui-addon-opt": "static-4.8264",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3004",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "ts-schema": "static-1.3981",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7567",
  "cssUtils": "static-1.764",
  "customer-data-ui-utilities": "static-1.9705",
  "HubStyle": "static-2.11632",
  "knowledge-content-types": "static-1.8438",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.514",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9768",
  "ui-addon-i18n": "static-1.11027",
  "ui-business-units-lib": "static-1.8918",
  "ui-shepherd-react": "static-3.10027",
  "video-components-external": "static-1.10848",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4206",
  "commerce-tours-lib": "static-1.5865",
  "customer-data-properties": "static-1.51082",
  "getting-started-shared-tasks": "static-1.18132",
  "growth-onboarding-reliability": "static-1.4968",
  "onboarding-tours": "static-1.16380",
  "reference-resolvers-lite": "static-1.7970",
  "sales-checkout-service-client": "static-1.3549",
  "ui-addon-iframeable": "static-1.8931",
  "user-context": "static-1.4981",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4554",
  "icons": "static-2.637",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.514",
  "quartz-head": "static-1.504",
  "quartz-test": "static-1.514",
  "quartz-tracking": "static-1.218",
  "ui-fonts": "static-1.586",
  "usage-tracker-container": "static-1.7207",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9309",
  "data-token-picker": "static-1.16190",
  "FileManagerLib": "static-1.38842",
  "property-translator": "static-1.5290",
  "atom": "static-1.4951",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5638",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.181",
  "foundations-components-test-utils": "static-1.5159",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.96",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-components": "static-1.3945",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "trellis-assets": "static-1.1454",
  "bend-plugin-foundations-theming": "static-1.2775",
  "foundations-theming-base": "static-1.3277",
  "stylex": "static-1.29",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5631",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4354",
  "react-flip-move": "static-1.67",
  "bender-build-tools": "static-1.3041",
  "inbound-db-properties-service-client": "static-1.3747",
  "superstore": "static-1.4649",
  "chirp-fetch": "static-1.1763",
  "feedback-loader": "static-1.29049",
  "ai-components-ui-library": "static-1.8608",
  "ui-addon-video-player": "static-1.8575",
  "ui-coaching-tips": "static-1.28180",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4500",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2374",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8047",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4532",
  "content-media-composition-data-lib": "static-1.11808",
  "content-media-compositions": "static-2.15815",
  "idb-keyval": "static-1.41",
  "immer": "static-1.33",
  "immerable": "static-1.4034",
  "magpie-lib": "static-1.5475",
  "magpie-types": "static-1.4935",
  "media-bridge-lib": "static-1.18710",
  "video-data-lib": "static-1.34506",
  "commerce-products-lib": "static-1.9085",
  "crm-message-bus": "static-1.42634",
  "growth-data-modal": "static-1.5242",
  "hubspot-apollo-client": "static-1.4760",
  "onboarding-tours-client": "static-1.4594",
  "calling-global-api": "static-1.64015",
  "calling-internal-common": "static-1.31182",
  "calling-lifecycle-internal": "static-1.65397",
  "calling-lifecycle-messages": "static-1.57691",
  "conditional-properties-service-client": "static-1.3699",
  "crm-links": "static-1.6154",
  "customer-data-objects-ui-components": "static-1.12897",
  "customer-data-property-utils": "static-1.7963",
  "external-options-client-types": "static-1.4060",
  "file-manager-components": "static-1.23202",
  "framework-data-schema-resolvers": "static-1.6756",
  "google-libphonenumber": "static-1.35",
  "hs-resources": "static-1.15",
  "inbound-db-meta-service-client": "static-1.3491",
  "inbounddb-objects-service-types": "static-1.4124",
  "meetings-icalendar-utils-lib": "static-1.512",
  "multi-currency-client-types": "static-1.3591",
  "object-builder-ui-client": "static-1.48311",
  "pipeline-validation-client-types": "static-1.3865",
  "property-value-citations": "static-1.1696",
  "pulse": "static-1.414",
  "smart-property-lib": "static-1.6315",
  "tiered-pricing": "static-1.972",
  "ui-addon-form-validation": "static-1.10873",
  "growth-onboarding-confetti": "static-1.2953",
  "growth-onboarding-next-action-utils": "static-1.1540",
  "navigation-components": "static-1.17570",
  "onboarding-tours-utils": "static-1.446",
  "ui-shepherd-tracker": "static-1.7408",
  "ui-universal-auth": "static-1.8804",
  "batch-promise": "static-1.1433",
  "navigation-messaging": "static-1.6897",
  "getting-started-shared-tasks-store": "static-1.17250",
  "hubspotter-http-shared-msw-handlers": "static-1.9675",
  "usage-tracker-session-replay": "static-1.4903",
  "audio-components": "static-1.5730",
  "FileManagerCore": "static-1.38701",
  "FileManagerImages": "static-1.36353",
  "video-components": "static-1.12851",
  "foundations-components-legacy": "static-1.701",
  "growth-monetization-service-types": "static-1.4379",
  "nav-client-types": "static-1.2238",
  "purchase-motions-api": "static-1.5641",
  "self-service-api": "static-1.10126",
  "signup-constants": "static-1.18602",
  "signup-ui-url-generator": "static-2.7916",
  "trials-service-types": "static-1.3780",
  "usage-tracker-public": "static-1.7028",
  "chatspot-core": "static-1.20718",
  "ContentUtils": "static-1.67904",
  "copilot-toolkit": "static-1.10770",
  "growth-onboarding-feedback-components": "static-1.6462",
  "reactive-lib": "static-1.605",
  "simple-logging-lib": "static-1.2931",
  "commerce-permissions": "static-1.645",
  "customer-data-tracking": "static-1.6764",
  "products-iframe-lib": "static-1.7573",
  "products-ui-components-shared-msw-handlers": "static-1.10059",
  "hubspot-apollo-cache": "static-1.219",
  "calling-error-reporting": "static-1.31188",
  "shared-worker-versioning": "static-1.10920",
  "calling-usage-tracker": "static-1.6423",
  "voice-sms-access-library": "static-1.513",
  "conversations-skeleton-state": "static-1.7130",
  "location-customization-utils-lib": "static-1.8839",
  "crm-pipelines-api-client-types": "static-1.4044",
  "framework-builder-read-service-client": "static-1.3910",
  "framework-data-schema-quick-fetch": "static-1.6661",
  "persist-promise": "static-1.3590",
  "directed-graph": "static-1.819",
  "event-emitter": "static-1.828",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5440",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9760",
  "fsm": "static-1.3612",
  "policy-lib": "static-1.6660",
  "react-tinymce": "static-1.54875",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9823",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54001",
  "tinymce-plugins": "static-1.57115",
  "tinymce-themes": "static-1.55971",
  "growth-onboarding-next-action-components": "static-1.1568",
  "user-context-client": "static-1.4493",
  "nest": "static-1.103",
  "unified-auth-core-lib": "static-1.599",
  "amplitude-session-replay-browser": "static-1.57",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4413",
  "video-embed": "static-1.35340",
  "content-icons-ui": "static-1.2188",
  "social-insights-client-types": "static-1.21686",
  "eligibility-engine-service-types": "static-1.3061",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4689",
  "integrations-lib": "static-1.15696",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4144",
  "calling-orchestration-schema": "static-1.35290",
  "crm-record-cards-service-types": "static-1.3513",
  "highcharts": "static-8.101",
  "trellis-story-utils": "static-1.4401",
  "storybook-react": "static-1.30",
  "hub-http-contrib": "static-1.2924",
  "interframe": "static-3.4643",
  "tinymce-data": "static-1.40086",
  "ui-addon-sales-email": "static-1.5093",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12204",
  "layout-dnd-utils": "static-1.11179",
  "react-codemirror": "static-1.10505",
  "ui-brand-identity-lib": "static-1.14536",
  "NamespacedHubStyle": "static-2.8970",
  "outpost": "static-1.4079",
  "flux-actions": "static-1.323",
  "integrations-error-boundary-lib": "static-1.13111",
  "integrations-tracking-lib": "static-1.5475",
  "native-integrations-shared-strings": "static-1.7668",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10255",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.318",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67979",
  "layout-data-lib": "static-1.9504",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2886",
  "advanced-menus-core": "static-1.14937",
  "advanced-menus-lib": "static-1.11903",
  "ExportDialog": "static-6.10269",
  "ui-memberships-settings-lib": "static-1.33688",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14936",
  "simple-menus-lib": "static-1.16453"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1883",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9557",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24983",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5476",
  "hs-test-utils": "/hs-test-utils/static-1.7893",
  "hub-http": "/hub-http/static-1.6100",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9677",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17865",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11324",
  "I18n": "/I18n/static-7.1598",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6351",
  "payment-link-components": "/payment-link-components/static-1.23171",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6839",
  "quartz-core": "/quartz-core/static-1.6058",
  "react": "/react/static-7.182",
  "react-colorpicker": "/react-colorpicker/static-2.10091",
  "react-dlb": "/react-dlb/static-1.74",
  "react-utils": "/react-utils/static-2.5249",
  "rich-text-lib": "/rich-text-lib/static-1.19619",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17797",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5462",
  "UIComponents": "/UIComponents/static-3.8271",
  "foundations-assets": "/foundations-assets/static-1.4721",
  "foundations-components": "/foundations-components/static-1.7676",
  "foundations-theming": "/foundations-theming/static-1.4292",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2008",
  "framer-motion": "/framer-motion/static-1.69",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.664",
  "quartz-config": "/quartz-config/static-1.617",
  "quartz-routing": "/quartz-routing/static-1.269",
  "quick-fetch": "/quick-fetch/static-1.3815",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16534",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8026",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.52",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4649",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9426",
  "usage-tracker": "/usage-tracker/static-1.7217",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5634",
  "usage-tracker-core": "/usage-tracker-core/static-1.7067",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3308",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3116",
  "quartz-webpack": "/quartz-webpack/static-1.3063",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.79",
  "customer-data-objects": "/customer-data-objects/static-1.7535",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7805",
  "laboratory-lib": "/laboratory-lib/static-3.7041",
  "onboarding-scopes": "/onboarding-scopes/static-1.6344",
  "rpc-client-utils": "/rpc-client-utils/static-1.4524",
  "ui-addon-opt": "/ui-addon-opt/static-4.8264",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3004",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "ts-schema": "/ts-schema/static-1.3981",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7567",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9705",
  "HubStyle": "/HubStyle/static-2.11632",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.514",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9768",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11027",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8918",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10027",
  "video-components-external": "/video-components-external/static-1.10848",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4206",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5865",
  "customer-data-properties": "/customer-data-properties/static-1.51082",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18132",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4968",
  "onboarding-tours": "/onboarding-tours/static-1.16380",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7970",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3549",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8931",
  "user-context": "/user-context/static-1.4981",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4554",
  "icons": "/icons/static-2.637",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.514",
  "quartz-head": "/quartz-head/static-1.504",
  "quartz-test": "/quartz-test/static-1.514",
  "quartz-tracking": "/quartz-tracking/static-1.218",
  "ui-fonts": "/ui-fonts/static-1.586",
  "usage-tracker-container": "/usage-tracker-container/static-1.7207",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9309",
  "data-token-picker": "/data-token-picker/static-1.16190",
  "FileManagerLib": "/FileManagerLib/static-1.38842",
  "property-translator": "/property-translator/static-1.5290",
  "atom": "/atom/static-1.4951",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5638",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5159",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.96",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3945",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "trellis-assets": "/trellis-assets/static-1.1454",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2775",
  "foundations-theming-base": "/foundations-theming-base/static-1.3277",
  "stylex": "/stylex/static-1.29",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5631",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4354",
  "react-flip-move": "/react-flip-move/static-1.67",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3747",
  "superstore": "/superstore/static-1.4649",
  "chirp-fetch": "/chirp-fetch/static-1.1763",
  "feedback-loader": "/feedback-loader/static-1.29049",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8608",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8575",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28180",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4500",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2374",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8047",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4532",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11808",
  "content-media-compositions": "/content-media-compositions/static-2.15815",
  "idb-keyval": "/idb-keyval/static-1.41",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4034",
  "magpie-lib": "/magpie-lib/static-1.5475",
  "magpie-types": "/magpie-types/static-1.4935",
  "media-bridge-lib": "/media-bridge-lib/static-1.18710",
  "video-data-lib": "/video-data-lib/static-1.34506",
  "commerce-products-lib": "/commerce-products-lib/static-1.9085",
  "crm-message-bus": "/crm-message-bus/static-1.42634",
  "growth-data-modal": "/growth-data-modal/static-1.5242",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4760",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4594",
  "calling-global-api": "/calling-global-api/static-1.64015",
  "calling-internal-common": "/calling-internal-common/static-1.31182",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65397",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57691",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3699",
  "crm-links": "/crm-links/static-1.6154",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12897",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7963",
  "external-options-client-types": "/external-options-client-types/static-1.4060",
  "file-manager-components": "/file-manager-components/static-1.23202",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6756",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-resources": "/hs-resources/static-1.15",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3491",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4124",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.512",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3591",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48311",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3865",
  "property-value-citations": "/property-value-citations/static-1.1696",
  "pulse": "/pulse/static-1.414",
  "smart-property-lib": "/smart-property-lib/static-1.6315",
  "tiered-pricing": "/tiered-pricing/static-1.972",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10873",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2953",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1540",
  "navigation-components": "/navigation-components/static-1.17570",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.446",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7408",
  "ui-universal-auth": "/ui-universal-auth/static-1.8804",
  "batch-promise": "/batch-promise/static-1.1433",
  "navigation-messaging": "/navigation-messaging/static-1.6897",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17250",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9675",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4903",
  "audio-components": "/audio-components/static-1.5730",
  "FileManagerCore": "/FileManagerCore/static-1.38701",
  "FileManagerImages": "/FileManagerImages/static-1.36353",
  "video-components": "/video-components/static-1.12851",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.701",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4379",
  "nav-client-types": "/nav-client-types/static-1.2238",
  "purchase-motions-api": "/purchase-motions-api/static-1.5641",
  "self-service-api": "/self-service-api/static-1.10126",
  "signup-constants": "/signup-constants/static-1.18602",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7916",
  "trials-service-types": "/trials-service-types/static-1.3780",
  "usage-tracker-public": "/usage-tracker-public/static-1.7028",
  "chatspot-core": "/chatspot-core/static-1.20718",
  "ContentUtils": "/ContentUtils/static-1.67904",
  "copilot-toolkit": "/copilot-toolkit/static-1.10770",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6462",
  "reactive-lib": "/reactive-lib/static-1.605",
  "simple-logging-lib": "/simple-logging-lib/static-1.2931",
  "commerce-permissions": "/commerce-permissions/static-1.645",
  "customer-data-tracking": "/customer-data-tracking/static-1.6764",
  "products-iframe-lib": "/products-iframe-lib/static-1.7573",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10059",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.219",
  "calling-error-reporting": "/calling-error-reporting/static-1.31188",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10920",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6423",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.513",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7130",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8839",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4044",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3910",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6661",
  "persist-promise": "/persist-promise/static-1.3590",
  "directed-graph": "/directed-graph/static-1.819",
  "event-emitter": "/event-emitter/static-1.828",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5440",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9760",
  "fsm": "/fsm/static-1.3612",
  "policy-lib": "/policy-lib/static-1.6660",
  "react-tinymce": "/react-tinymce/static-1.54875",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9823",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54001",
  "tinymce-plugins": "/tinymce-plugins/static-1.57115",
  "tinymce-themes": "/tinymce-themes/static-1.55971",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1568",
  "user-context-client": "/user-context-client/static-1.4493",
  "nest": "/nest/static-1.103",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.599",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4413",
  "video-embed": "/video-embed/static-1.35340",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "social-insights-client-types": "/social-insights-client-types/static-1.21686",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3061",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4689",
  "integrations-lib": "/integrations-lib/static-1.15696",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4144",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35290",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3513",
  "highcharts": "/highcharts/static-8.101",
  "trellis-story-utils": "/trellis-story-utils/static-1.4401",
  "storybook-react": "/storybook-react/static-1.30",
  "hub-http-contrib": "/hub-http-contrib/static-1.2924",
  "interframe": "/interframe/static-3.4643",
  "tinymce-data": "/tinymce-data/static-1.40086",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5093",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12204",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11179",
  "react-codemirror": "/react-codemirror/static-1.10505",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14536",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8970",
  "outpost": "/outpost/static-1.4079",
  "flux-actions": "/flux-actions/static-1.323",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13111",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5475",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7668",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10255",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.318",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67979",
  "layout-data-lib": "/layout-data-lib/static-1.9504",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2886",
  "advanced-menus-core": "/advanced-menus-core/static-1.14937",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11903",
  "ExportDialog": "/ExportDialog/static-6.10269",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33688",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14936",
  "simple-menus-lib": "/simple-menus-lib/static-1.16453"
}
};
